import React from "react";
import { DollarSign, Clock, Eye, Zap, Handshake, ShieldCheck, Phone, MessageCircle } from "lucide-react";
import { WHATSAPP_URL, TEL_PRIMARY } from "../lib/business";

const REASONS = [
  { icon: DollarSign, title: "Cobrimos qualquer orçamento", desc: "Mostrou outro valor? A gente cobre. Simples assim." },
  { icon: Zap, title: "Atendimento sem enrolação", desc: "Falou, saímos. Sem papo furado, sem rodeio." },
  { icon: Clock, title: "Equipe pronta 24 horas", desc: "Dia, noite, feriado ou madrugada. Sempre prontos." },
  { icon: Eye, title: "Transparência total no valor", desc: "Preço passado antes. Sem surpresa no final." },
  { icon: Handshake, title: "Atendimento humanizado", desc: "Entendemos sua situação. Resolvemos com respeito." },
  { icon: ShieldCheck, title: "Rapidez e segurança", desc: "Deslocamento rápido com total cuidado no transporte." },
];

export default function WhyUs() {
  return (
    <section
      data-testid="whyus-section"
      className="bg-gradient-to-b from-[#0A0A0A] to-[#171717] py-16 md:py-24 relative"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block bg-[#E50914] px-3 py-1 mb-4">
            <span className="font-anton text-sm uppercase tracking-widest text-white">Por que escolher</span>
          </div>
          <h2 className="font-anton text-4xl md:text-6xl uppercase text-white leading-[0.95] mb-4">
            Precisou de Guincho?
            <br />
            <span className="text-[#E50914]">Não pague caro sem necessidade.</span>
          </h2>
          <p className="font-work text-lg text-zinc-300 max-w-2xl mx-auto">
            Somos o guincho mais barato de Araçoiaba da Serra e região — com qualidade de quem respeita o cliente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12">
          {REASONS.map((r, i) => (
            <div
              key={r.title}
              data-testid={`whyus-card-${i}`}
              className="bg-black border-l-4 border-[#E50914] p-6 md:p-7 hover-lift transition-all"
            >
              <r.icon className="w-8 h-8 text-[#E50914] mb-4" strokeWidth={2} />
              <h3 className="font-anton text-xl md:text-2xl text-white uppercase leading-tight mb-2">
                {r.title}
              </h3>
              <p className="font-work text-sm md:text-base text-zinc-400 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA banner */}
        <div className="bg-[#E50914] p-6 md:p-10 text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 stripes opacity-40" aria-hidden />
          <h3 className="font-anton text-3xl md:text-5xl uppercase text-white leading-none mb-4">
            Solicite seu orçamento em menos de 1 minuto
          </h3>
          <p className="font-work text-white/90 text-base md:text-lg mb-6 max-w-xl mx-auto">
            Estamos prontos agora. Chame no WhatsApp ou ligue direto.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whyus-whatsapp-button"
              className="bg-[#25D366] hover:bg-[#1EBE5D] text-white font-anton uppercase text-lg md:text-xl tracking-wider px-7 py-4 inline-flex items-center justify-center gap-2 transition-all hover:-translate-y-1 rounded-sm"
            >
              <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
              WhatsApp Agora
            </a>
            <a
              href={TEL_PRIMARY}
              data-testid="whyus-call-button"
              className="bg-black hover:bg-zinc-900 text-white font-anton uppercase text-lg md:text-xl tracking-wider px-7 py-4 inline-flex items-center justify-center gap-2 transition-all hover:-translate-y-1 rounded-sm"
            >
              <Phone className="w-5 h-5" strokeWidth={2.5} />
              Ligar Agora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
